export default __webpack_public_path__ + "static/media/card-item.c3e55e53.svg";